import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import VideoPlayer from './videojswithhls/VideoPlayerJsWithHls';

// TODO: Use VideoDto
export interface Video {
  id: string;
  status: string;
  title: string;
  description?: string;
  image_url?: string;
  playlist_url?: string;
  original_video_url?: string;
  created_at: string;
  updated_at: string;
}

// TODO: Use CompanyDto
interface Company {
  id: string;
  status: string;
  company_name: string;
  company_description: string;
  company_image?: string;
  intro_video?: Video;
  outro_video?: Video;
}

// TODO: Use PlaylistDto
interface DistrictPlaylist {
  id: string;
  status: string;
  playlist_name: string;
  playlist_url?: string;
  created_at: string;
  district_name: string;
}

const VideoPageVideoHls = () => {

  const { districtId } = useParams();
  const [districtPlaylists, setDistrictPlaylists] = useState<DistrictPlaylist[]>([]);
  const [districtData, setDistrictData] = useState<Company | null>(null);
  const backendApiUrl = process.env.NEXT_PUBLIC_BACKEND_API_URL;

  useEffect(() => {
    // Fetch video URL
    fetch(`${backendApiUrl}/api/districts/${districtId}/playlists`)
      .then(response => response.json())
      .then(data => setDistrictPlaylists(data.items))
      .catch(error => console.error('Error fetching video URL:', error));

    fetch(`${backendApiUrl}/api/districts/${districtId}`)
      .then(response => response.json())
      .then(data => setDistrictData(data))
      .catch(error => console.error('Error fetching district data:', error));

  }, [districtId]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="max-w-xl w-full rounded-lg">
        {districtData && (
          <div className="m-8 text-center bg-white p-6">
            <h1 className="text-2xl font-bold">District name: {districtData.company_name}</h1>
            <p className="text-xl font-bold">District description: {districtData.company_description}</p>
          </div>
        )}
        {districtPlaylists.map((video) => (
          <div className="m-8 bg-white">
            <h1 className="text-xl font-bold text-center mb-4">Video name: {video.playlist_name}</h1>
            <div className="aspect-w-16 aspect-h-9">
              <VideoPlayer
                options={{
                  autoplay: false,
                  sources: [
                    {
                      src: video?.playlist_url ?? '',
                      type: 'application/x-mpegURL'
                    }
                  ]
                }}
              />
            </div>
          </div>
        ))
        }
      </div>
    </div>
  );
};

export default VideoPageVideoHls;
